var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarbonIbmCloudDirectLink1DedicatedHosting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6562 13.5938H6.09375C5.57812 13.5938 5.15625 13.1719 5.15625 12.6562V10.7812H6.09375V12.6562H12.6562V6.09375H10.7812V5.15625H12.6562C13.1719 5.15625 13.5938 5.57812 13.5938 6.09375V12.6562C13.5938 13.1719 13.1719 13.5938 12.6562 13.5938Z",
    fill: "#990A02"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15625 8.90625H9.84375V9.84375H5.15625V8.90625ZM5.15625 7.03125H9.84375V7.96875H5.15625V7.03125ZM5.15625 5.15625H9.84375V6.09375H5.15625V5.15625Z",
    fill: "#990A02"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.34375 1.40625H8.90625C9.42188 1.40625 9.84375 1.82812 9.84375 2.34375V4.21875H8.90625V2.34375H2.34375V8.90625H4.21875V9.84375H2.34375C1.82812 9.84375 1.40625 9.42188 1.40625 8.90625V2.34375C1.40625 1.82812 1.82812 1.40625 2.34375 1.40625Z",
    fill: "#990A02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonIbmCloudDirectLink1DedicatedHosting);
export default __webpack_public_path__ + "static/media/carbon_ibm-cloud-direct-link-1-dedicated-hosting.41d6ca259f6a0899501edec35fd1cdb1.svg";
export { ForwardRef as ReactComponent };